<script lang="ts" setup>
import { DropdownWithoutAlgoliaProps } from "~/components/Filters/Utils/DropdownWithoutAlgolia.props"

const props = withDefaults(defineProps<DropdownWithoutAlgoliaProps>(), {
  contentClass: "",
  attachTo: "left",
  opened: false,
  hideControls: false
})

const emit =
  defineEmits<{
    (e: "onOpen"): void
    (e: "onClose"): void
  }>()

const dropdownRef = ref<HTMLDivElement | null>(null)
const onLeftSide = computed(() => props.attachTo === "left")

const closeDropdown = (resetOptions: boolean = true) => {
  if (!props.opened) emit("onOpen")
  if (resetOptions) emit("onClose")
}

onClickOutside(dropdownRef, () => {
  if (!props.opened) return
  closeDropdown()
})
</script>

<template>
  <div ref="dropdownRef" class="dropdown relative inline-block">
    <FiltersUtilsDropdownButton
      class="beaver-medium"
      :text="text"
      :opened="opened"
      @onClick="() => closeDropdown(false)"
    />
    <Transition name="slide-fade" appear>
      <div
        v-show="opened"
        class="
          dropdown__content
          absolute
          top-full
          z-[9999]
          rounded-b-lg
          bg-white
          shadow-02
        "
        :class="[
          contentClass,
          { 'left-0': onLeftSide, 'right-0': !onLeftSide }
        ]"
      >
        <slot />
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

</style>
